import { useState } from "react";
import { Link } from "react-router-dom";

const CATEGORY_COLORS: Record<string, string> = {
  Electronics: "bg-orange-50 text-orange-600",
  Beauty: "bg-rose-50 text-rose-600",
  Sports: "bg-green-50 text-green-600",
  Home: "bg-amber-50 text-amber-600",
  Fashion: "bg-indigo-50 text-indigo-600",
  "Food & Beverage": "bg-lime-50 text-lime-600",
  Automotive: "bg-gray-100 text-gray-600",
  Industrial: "bg-stone-100 text-stone-600",
  Furniture: "bg-yellow-50 text-yellow-700",
  Toys: "bg-pink-50 text-pink-600",
};

const buyerLeads = [
  { id: "1", flag: "🇬🇧", country: "United Kingdom", company: "UKTech Distribution Ltd.", title: "Wireless Earbuds ANC — 5,000 Units", category: "Electronics", quantity: "5,000 units", budget: "$180K–$220K", delivery: "Jun 2026", postedAt: "2h ago", containers: "2 x 40HQ" },
  { id: "2", flag: "🇩🇪", country: "Germany", company: "BüroTech GmbH", title: "Smart LED Desk Lamps USB-C — 8,000 Units", category: "Home", quantity: "8,000 units", budget: "$160K–$200K", delivery: "Aug 2026", postedAt: "4h ago", containers: "3 x 40HQ" },
  { id: "3", flag: "🇦🇺", country: "Australia", company: "FitAustralia Wholesale", title: "Resistance Bands 5-Level Sets — 20,000 Sets", category: "Sports", quantity: "20,000 sets", budget: "$120K–$160K", delivery: "Jul 2026", postedAt: "6h ago", containers: "4 x 40HQ" },
  { id: "4", flag: "🇨🇦", country: "Canada", company: "Glow Beauty Canada Inc.", title: "Vitamin C & Hyaluronic Serum — 10,000 Units", category: "Beauty", quantity: "10,000 units", budget: "$90K–$130K", delivery: "May 2026", postedAt: "8h ago", containers: "1 x 40HQ" },
  { id: "5", flag: "🇯🇵", country: "Japan", company: "TechShop Japan Co., Ltd.", title: "IPX7 Bluetooth Speakers — 3,000 Units", category: "Electronics", quantity: "3,000 units", budget: "$80K–$110K", delivery: "Jun 2026", postedAt: "10h ago", containers: "1 x 20GP" },
  { id: "6", flag: "🇫🇷", country: "France", company: "Mode Paris SAS", title: "GOTS Organic Cotton Hoodies — 15,000 Pcs", category: "Fashion", quantity: "15,000 pcs", budget: "$300K–$400K", delivery: "Sep 2026", postedAt: "12h ago", containers: "5 x 40HQ" },
  { id: "7", flag: "🇧🇷", country: "Brazil", company: "TechBrasil Distribuidora", title: "Budget TWS Earbuds — 10,000 Units", category: "Electronics", quantity: "10,000 units", budget: "$120K–$150K", delivery: "Jul 2026", postedAt: "14h ago", containers: "2 x 40HQ" },
  { id: "8", flag: "🇦🇪", country: "UAE", company: "Gulf Trade Partners LLC", title: "Stainless Steel Water Bottles — 25,000 Units", category: "Sports", quantity: "25,000 units", budget: "$200K–$260K", delivery: "Aug 2026", postedAt: "16h ago", containers: "3 x 40HQ" },
  { id: "9", flag: "🇰🇷", country: "South Korea", company: "Seoul Beauty Hub Co.", title: "Collagen Peptide Powder 500g — 8,000 Units", category: "Beauty", quantity: "8,000 units", budget: "$110K–$140K", delivery: "Jun 2026", postedAt: "18h ago", containers: "1 x 40HQ" },
  { id: "10", flag: "🇮🇳", country: "India", company: "Mumbai Electronics Pvt. Ltd.", title: "Smart Home Hub WiFi Devices — 5,000 Units", category: "Electronics", quantity: "5,000 units", budget: "$60K–$90K", delivery: "Oct 2026", postedAt: "20h ago", containers: "1 x 40HQ" },
  { id: "11", flag: "🇲🇽", country: "Mexico", company: "Distribuidora MX S.A.", title: "Bamboo Cutting Board Sets — 12,000 Sets", category: "Home", quantity: "12,000 sets", budget: "$80K–$110K", delivery: "Jul 2026", postedAt: "22h ago", containers: "2 x 40HQ" },
  { id: "12", flag: "🇸🇬", country: "Singapore", company: "SG Lifestyle Imports Pte.", title: "Noise Cancelling Headphones — 2,000 Units", category: "Electronics", quantity: "2,000 units", budget: "$140K–$180K", delivery: "Sep 2026", postedAt: "1d ago", containers: "1 x 20GP" },
  { id: "13", flag: "🇳🇱", country: "Netherlands", company: "EuroTrade B.V.", title: "Adjustable Dumbbell Sets 5–52lbs — 3,000 Sets", category: "Sports", quantity: "3,000 sets", budget: "$250K–$320K", delivery: "Aug 2026", postedAt: "1d ago", containers: "4 x 40HQ" },
  { id: "14", flag: "🇿🇦", country: "South Africa", company: "Cape Town Retail Group", title: "Ceramic Pour-Over Coffee Sets — 6,000 Sets", category: "Home", quantity: "6,000 sets", budget: "$70K–$95K", delivery: "Oct 2026", postedAt: "1d ago", containers: "1 x 40HQ" },
  { id: "15", flag: "🇹🇷", country: "Turkey", company: "Istanbul Fashion House", title: "Merino Wool Beanies 6 Colors — 30,000 Pcs", category: "Fashion", quantity: "30,000 pcs", budget: "$180K–$240K", delivery: "Nov 2026", postedAt: "1d ago", containers: "3 x 40HQ" },
  { id: "16", flag: "🇮🇹", country: "Italy", company: "Milano Home Decor S.r.l.", title: "Smart LED Strip Lights RGB — 15,000 Sets", category: "Home", quantity: "15,000 sets", budget: "$90K–$120K", delivery: "Sep 2026", postedAt: "2d ago", containers: "2 x 40HQ" },
  { id: "17", flag: "🇸🇦", country: "Saudi Arabia", company: "Riyadh Trading Co.", title: "4K Action Cameras Waterproof — 4,000 Units", category: "Electronics", quantity: "4,000 units", budget: "$200K–$260K", delivery: "Jul 2026", postedAt: "2d ago", containers: "1 x 40HQ" },
  { id: "18", flag: "🇵🇱", country: "Poland", company: "Warsaw Sports Wholesale", title: "Yoga Mat Premium Non-Slip — 20,000 Units", category: "Sports", quantity: "20,000 units", budget: "$100K–$140K", delivery: "Aug 2026", postedAt: "2d ago", containers: "3 x 40HQ" },
  { id: "19", flag: "🇦🇷", country: "Argentina", company: "Buenos Aires Toys S.A.", title: "Educational STEM Toy Kits — 8,000 Sets", category: "Toys", quantity: "8,000 sets", budget: "$80K–$110K", delivery: "Oct 2026", postedAt: "2d ago", containers: "2 x 40HQ" },
  { id: "20", flag: "🇳🇬", country: "Nigeria", company: "Lagos Auto Parts Ltd.", title: "Car Dash Cam 4K Dual Lens — 6,000 Units", category: "Automotive", quantity: "6,000 units", budget: "$120K–$160K", delivery: "Sep 2026", postedAt: "3d ago", containers: "1 x 40HQ" },
];

const WELCOME_FLAGS = ["🇺🇸","🇬🇧","🇩🇪","🇯🇵","🇦🇺","🇨🇦","🇫🇷","🇰🇷","🇮🇳","🇧🇷","🇦🇪","🇸🇬","🇮🇹","🇳🇱","🇹🇷","🇸🇦","🇵🇱","🇲🇽","🇿🇦","🇦🇷"];

const SUBMIT_COUNTRIES = [
  "United States","United Kingdom","Canada","Australia","Germany","France","Japan",
  "South Korea","Singapore","UAE","Saudi Arabia","Brazil","Mexico","India",
  "Netherlands","Italy","Spain","Turkey","South Africa","Nigeria","Argentina",
  "Poland","New Zealand","Sweden","Thailand","Vietnam","Indonesia","Malaysia",
];

const CATEGORIES_LIST = [
  "Electronics","Fashion","Home & Living","Beauty & Skincare",
  "Sports & Fitness","Food & Beverage","Toys & Kids","Automotive","Industrial","Furniture",
];

interface QuickForm {
  buyerName: string; company: string; email: string; whatsapp: string;
  country: string; category: string; title: string; quantity: string;
  budget: string; targetDelivery: string; description: string; agreePrivacy: boolean;
}

export default function BuyerRequirementsSection() {
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState<QuickForm>({
    buyerName: "", company: "", email: "", whatsapp: "", country: "", category: "",
    title: "", quantity: "", budget: "", targetDelivery: "", description: "", agreePrivacy: false,
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const set = (field: string, value: string | boolean) => {
    setForm((p) => ({ ...p, [field]: value }));
    setErrors((p) => ({ ...p, [field]: "" }));
  };

  const validate = () => {
    const e: Record<string, string> = {};
    if (!form.buyerName.trim()) e.buyerName = "Required";
    if (!form.email.trim()) e.email = "Required";
    if (!form.whatsapp.trim()) e.whatsapp = "Required";
    if (!form.country) e.country = "Required";
    if (!form.category) e.category = "Required";
    if (!form.title.trim()) e.title = "Required";
    if (!form.quantity.trim()) e.quantity = "Required";
    if (!form.description.trim()) e.description = "Required";
    if (form.description.length > 500) e.description = "Max 500 characters";
    if (!form.agreePrivacy) e.agreePrivacy = "Required";
    return e;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      Object.entries(form).forEach(([k, v]) => body.append(k, String(v)));
      await fetch("https://readdy.ai/api/form/d7e0g245q56ra7tufsgg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <section className="overflow-hidden">

      {/* ===== WELCOME HERO BANNER ===== */}
      <div className="relative">
        <img
          src="https://public.readdy.ai/ai/img_res/115233181b0358d0b74805f48ad1fcdc.jpg"
          alt="Global Buyers Welcome"
          className="w-full h-[280px] sm:h-[340px] md:h-[440px] object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(115deg, rgba(140,88,0,0.94) 0%, rgba(190,130,0,0.88) 35%, rgba(230,170,0,0.70) 65%, rgba(245,185,0,0.25) 100%)" }} />

        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-4 md:px-12 w-full">
            <div className="max-w-2xl">
              {/* Badge */}
              <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-5 flex-wrap">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-orange-500 text-white text-xs font-bold rounded-full uppercase tracking-widest">
                  <i className="ri-global-line" /> Global Buyer Board
                </span>
                <span className="flex items-center gap-1.5 text-xs text-white/60">
                  <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse inline-block" />
                  Live · Updated every hour
                </span>
              </div>

              {/* Headline */}
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-white leading-tight mb-3 md:mb-4">
                Buyers from Every Country<br />
                <span className="text-orange-400">Are Welcome Here</span>
              </h2>
              <p className="text-white/75 text-xs sm:text-sm md:text-base leading-relaxed mb-4 md:mb-6 max-w-xl">
                Submit your bulk order requirement for <strong className="text-white">free</strong>. Your WhatsApp &amp; email stay <strong className="text-white">100% private</strong> — only paid membership verified factories can see your contact and send quotations directly to your inbox.
              </p>

              {/* Country Flags */}
              <div className="flex flex-wrap gap-1.5 md:gap-2 mb-4 md:mb-7">
                {WELCOME_FLAGS.map((f) => (
                  <span key={f} className="text-lg md:text-xl">{f}</span>
                ))}
                <span className="text-xs text-white/50 self-center ml-1">+100 more countries</span>
              </div>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
                <button
                  onClick={() => setShowForm(true)}
                  className="flex items-center justify-center gap-2 px-5 md:px-7 py-3 md:py-3.5 bg-orange-500 text-white text-sm font-bold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-add-circle-line text-base" /> Post Your Requirement — Free
                </button>
                <Link
                  to="/membership"
                  className="flex items-center justify-center gap-2 px-5 md:px-7 py-3 md:py-3.5 bg-white/10 border border-white/30 text-white text-sm font-semibold rounded-full hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-vip-crown-line" /> Factory? Unlock Contacts — $8/mo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== HOW IT WORKS STRIP ===== */}
      <div className="bg-gray-900 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 md:py-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {[
              { icon: "ri-file-add-line", title: "Buyer Posts Free", desc: "Submit your bulk order requirement from any country — completely free", color: "text-orange-400" },
              { icon: "ri-lock-line", title: "Contact Stays Private", desc: "Email & WhatsApp hidden from public — never visible without membership", color: "text-green-400" },
              { icon: "ri-vip-crown-line", title: "Factory Unlocks ($8/mo)", desc: "Paid verified factories access your contact and send quotations", color: "text-amber-400" },
              { icon: "ri-mail-check-line", title: "Quotation to Your Email", desc: "Factories send quotes directly to your email — you choose who to reply", color: "text-orange-400" },
            ].map((s, i) => (
              <div key={s.title} className="flex items-start gap-3">
                <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-white/10 mt-0.5">
                  <span className="text-xs font-bold text-white/50">{i + 1}</span>
                </div>
                <div>
                  <p className={`text-sm font-bold mb-0.5 ${s.color}`}>{s.title}</p>
                  <p className="text-xs text-white/50 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ===== MAIN CONTENT ===== */}
      <div className="py-12 px-4 md:px-8" style={{ backgroundColor: "#f7f6f3" }}>
        <div className="max-w-7xl mx-auto">

          {/* Stats + Factory Unlock Banner */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-8">
            {[
              { value: "2,400+", label: "Active Requirements", icon: "ri-file-list-3-line", color: "text-orange-500 bg-orange-50" },
              { value: "120+", label: "Countries", icon: "ri-global-line", color: "text-green-600 bg-green-50" },
              { value: "$2.8B+", label: "Total Order Value", icon: "ri-money-dollar-circle-line", color: "text-orange-500 bg-orange-50" },
              { value: "850+", label: "Verified Factories", icon: "ri-building-2-line", color: "text-amber-600 bg-amber-50" },
            ].map((s) => (
              <div key={s.label} className="bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0 ${s.color}`}>
                  <i className={`${s.icon} text-lg`} />
                </div>
                <div>
                  <p className="text-xl font-extrabold text-gray-900">{s.value}</p>
                  <p className="text-xs text-gray-400">{s.label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Factory Unlock Banner */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-gradient-to-r from-orange-500 to-amber-500 rounded-2xl px-6 py-5 mb-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                <i className="ri-lock-unlock-line text-white text-2xl" />
              </div>
              <div>
                <p className="text-white font-bold text-base">Are You a Verified Factory?</p>
                <p className="text-white/80 text-xs mt-0.5">Upgrade to Factory Membership ($8/mo) — view buyer email, WhatsApp &amp; send quotations directly to close bulk deals</p>
              </div>
            </div>
            <Link to="/membership" className="px-6 py-2.5 bg-white text-orange-600 text-sm font-bold rounded-full hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0">
              Upgrade Now — $8/mo
            </Link>
          </div>

          {/* Section Title */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            <div>
              <h3 className="text-xl font-extrabold text-gray-900">Live Buyer Requirements</h3>
              <p className="text-sm text-gray-500 mt-0.5">Contact info is locked — only paid factory members can view &amp; send quotations</p>
            </div>
            <Link to="/buyer-requirements" className="flex items-center gap-2 px-5 py-2.5 border border-gray-300 text-gray-700 text-sm font-semibold rounded-full hover:border-orange-400 hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap">
              View All 2,400+ <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Buyer Leads Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
            {buyerLeads.map((lead) => {
              const catColor = CATEGORY_COLORS[lead.category] || "bg-gray-100 text-gray-600";
              return (
                <div key={lead.id} className="bg-white rounded-2xl border border-gray-100 hover:border-orange-200 transition-all p-5">
                  {/* Top Row */}
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <div className="flex items-center gap-2.5 flex-1 min-w-0">
                      <span className="text-2xl flex-shrink-0">{lead.flag}</span>
                      <div className="min-w-0">
                        <p className="text-xs text-gray-400 truncate">{lead.country} · {lead.company}</p>
                        <h4 className="text-sm font-bold text-gray-900 leading-snug mt-0.5 line-clamp-1">{lead.title}</h4>
                      </div>
                    </div>
                    <div className="flex flex-col items-end gap-1 flex-shrink-0">
                      <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${catColor}`}>{lead.category}</span>
                      <span className="text-xs text-gray-400">{lead.postedAt}</span>
                    </div>
                  </div>

                  {/* Stats */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    <span className="flex items-center gap-1 text-xs bg-gray-50 text-gray-600 px-2.5 py-1 rounded-lg font-medium">
                      <i className="ri-box-3-line text-orange-400" /> {lead.quantity}
                    </span>
                    <span className="flex items-center gap-1 text-xs bg-gray-50 text-gray-600 px-2.5 py-1 rounded-lg font-medium">
                      <i className="ri-money-dollar-circle-line text-green-500" /> {lead.budget}
                    </span>
                    <span className="flex items-center gap-1 text-xs bg-gray-50 text-gray-600 px-2.5 py-1 rounded-lg font-medium">
                      <i className="ri-ship-line text-orange-400" /> {lead.containers}
                    </span>
                    <span className="flex items-center gap-1 text-xs bg-gray-50 text-gray-600 px-2.5 py-1 rounded-lg font-medium">
                      <i className="ri-calendar-line text-gray-400" /> {lead.delivery}
                    </span>
                  </div>

                  {/* Locked Contact */}
                  <div className="flex items-center justify-between gap-3 bg-gray-50 rounded-xl px-4 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-white rounded-full border border-gray-200 flex-shrink-0">
                        <i className="ri-lock-line text-gray-400 text-sm" />
                      </div>
                      <div>
                        <p className="text-xs font-bold text-gray-700">Contact Info Hidden</p>
                        <div className="flex items-center gap-3 mt-0.5">
                          <span className="text-xs text-gray-300 blur-sm select-none">buyer@company.com</span>
                          <span className="text-xs text-gray-300 blur-sm select-none">+44 7911 xxxxxx</span>
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/membership"
                      className="flex items-center gap-1 px-3 py-1.5 bg-orange-500 text-white text-xs font-bold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-vip-crown-line" /> Unlock
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom Dual CTA */}
          <div className="relative rounded-3xl overflow-hidden" style={{ minHeight: 480 }}>
            <img
              src="https://readdy.ai/api/search-image?query=beautiful%20blonde%20hair%20woman%20businesswoman%20smiling%20confidently%20at%20camera%20holding%20documents%20standing%20in%20bright%20luxury%20gold%20office%20professional%20executive%20attractive%20glamorous%20warm%20golden%20light%20background&width=1400&height=600&seq=buyercta-gold-blonde&orientation=landscape"
              alt="For Global Buyers"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            {/* Rich gold gradient overlay */}
            <div className="absolute inset-0" style={{ background: "linear-gradient(115deg, rgba(161,104,0,0.96) 0%, rgba(202,148,0,0.91) 30%, rgba(245,185,0,0.78) 58%, rgba(251,200,50,0.35) 100%)" }} />
            {/* Diagonal shimmer lines */}
            <div className="absolute inset-0 opacity-10" style={{ background: "repeating-linear-gradient(55deg, transparent, transparent 50px, rgba(255,255,255,0.3) 50px, rgba(255,255,255,0.3) 52px)" }} />

            <div className="relative z-10 flex flex-col lg:flex-row items-start lg:items-center gap-8 md:gap-10 px-5 sm:px-8 md:px-16 py-10 md:py-16 lg:py-20">

              {/* Left: Main content */}
              <div className="flex-1 max-w-2xl">
                {/* Live urgency badge */}
                <div className="flex flex-wrap items-center gap-3 mb-4 md:mb-6">
                  <span className="inline-flex items-center gap-2 bg-white text-amber-800 text-xs font-extrabold uppercase tracking-widest px-4 py-2 rounded-full" style={{ boxShadow: "0 4px 16px rgba(0,0,0,0.15)" }}>
                    <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                    850+ Factories Waiting to Quote You Right Now
                  </span>
                </div>

                {/* Big headline */}
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4 md:mb-5 drop-shadow">
                  For Global Buyers<br />
                  <span className="text-white/90">Post Your Bulk Order</span><br />
                  <span className="underline decoration-white/40 decoration-4">100% Free</span>
                </h2>

                <p className="text-white text-sm md:text-base lg:text-lg leading-relaxed mb-5 md:mb-7 max-w-xl font-medium">
                  Submit your container order requirement right now. Your <strong>email &amp; WhatsApp stay 100% private</strong> — only paid verified factories can see your contact and send quotations directly to your inbox.
                </p>

                {/* 3 trust pillars */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 md:gap-3 mb-6 md:mb-8">
                  {[
                    { icon: "ri-lock-fill", text: "Contact 100% Private" },
                    { icon: "ri-shield-check-fill", text: "Verified Factories Only" },
                    { icon: "ri-mail-check-line", text: "Quotes Sent to Your Email" },
                  ].map((item) => (
                    <div key={item.text} className="flex items-center gap-2.5 bg-white/20 backdrop-blur-sm border border-white/40 rounded-xl px-3 py-3">
                      <i className={`${item.icon} text-white text-lg flex-shrink-0`} />
                      <span className="text-white text-xs md:text-sm font-bold">{item.text}</span>
                    </div>
                  ))}
                </div>

                {/* Country flags */}
                <div className="flex flex-wrap gap-1.5 md:gap-2 mb-6 md:mb-8">
                  {["🇺🇸","🇬🇧","🇩🇪","🇯🇵","🇦🇺","🇨🇦","🇫🇷","🇰🇷","🇮🇳","🇧🇷","🇦🇪","🇸🇬","🇮🇹","🇳🇱","🇹🇷","🇸🇦"].map((f) => (
                    <span key={f} className="text-xl md:text-2xl drop-shadow">{f}</span>
                  ))}
                  <span className="text-xs md:text-sm text-white/80 font-semibold self-center ml-1">+100 countries</span>
                </div>

                {/* CTA buttons */}
                <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                  <button
                    onClick={() => setShowForm(true)}
                    className="flex items-center justify-center gap-2 md:gap-3 px-6 md:px-10 py-4 md:py-5 bg-white font-extrabold rounded-2xl hover:bg-yellow-50 transition-all cursor-pointer whitespace-nowrap text-sm md:text-base"
                    style={{ color: "#92600a", boxShadow: "0 8px 32px rgba(0,0,0,0.22)" }}
                  >
                    <i className="ri-add-circle-fill text-lg md:text-xl" />
                    Post Your Requirement — FREE
                  </button>
                  <Link
                    to="/membership"
                    className="flex items-center justify-center gap-2 px-6 md:px-8 py-4 md:py-5 bg-white/15 border-2 border-white/50 text-white text-sm font-bold rounded-2xl hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-vip-crown-line text-lg" />
                    Factory? Unlock Contacts — $8/mo
                  </Link>
                </div>

                <p className="text-white/80 text-xs md:text-sm mt-4 md:mt-5 font-medium">
                  <i className="ri-timer-flash-line mr-1" />
                  Average response time: <strong className="text-white">under 2 hours</strong> · Factories are online now and ready to quote
                </p>
              </div>

              {/* Right: Live stats card */}
              <div className="flex-shrink-0 w-full lg:w-80">
                <div className="bg-white/15 backdrop-blur-md border border-white/30 rounded-2xl p-5 md:p-6 space-y-3">
                  <p className="text-white font-extrabold text-base text-center mb-1">Live Platform Stats</p>
                  {[
                    { icon: "ri-file-list-3-line", value: "2,400+", label: "Active Buyer Requirements" },
                    { icon: "ri-building-2-line", value: "850+", label: "Verified Factories Ready" },
                    { icon: "ri-global-line", value: "120+", label: "Countries Represented" },
                    { icon: "ri-money-dollar-circle-line", value: "$2.8B+", label: "Total Order Value Posted" },
                    { icon: "ri-timer-flash-line", value: "< 2 hrs", label: "Avg. Quotation Response" },
                  ].map((s) => (
                    <div key={s.label} className="flex items-center gap-3 bg-white/10 rounded-xl px-3 md:px-4 py-2.5 md:py-3">
                      <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                        <i className={`${s.icon} text-white text-sm md:text-base`} />
                      </div>
                      <div>
                        <p className="text-white font-extrabold text-base md:text-lg leading-none">{s.value}</p>
                        <p className="text-white/70 text-xs mt-0.5">{s.label}</p>
                      </div>
                    </div>
                  ))}
                  <button
                    onClick={() => setShowForm(true)}
                    className="w-full py-3.5 md:py-4 bg-white font-extrabold rounded-xl hover:bg-yellow-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 mt-2 text-sm"
                    style={{ color: "#92600a" }}
                  >
                    <i className="ri-send-plane-fill text-base" /> Submit Now — It&apos;s Free
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* For Factories strip */}
          <div className="mt-6 bg-white rounded-2xl border border-gray-100 p-6 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-xl flex-shrink-0">
                <i className="ri-building-2-line text-amber-500 text-2xl" />
              </div>
              <div>
                <p className="text-base font-extrabold text-gray-900">For Verified Factories — Unlock Buyer Contacts &amp; Win Deals</p>
                <div className="flex flex-wrap gap-4 mt-1">
                  {["View buyer email & WhatsApp", "Send quotations directly", "Close bulk container deals globally", "Only $8/month"].map((p) => (
                    <span key={p} className="flex items-center gap-1 text-xs text-gray-500">
                      <i className="ri-checkbox-circle-fill text-orange-500" />{p}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/membership"
              className="flex-shrink-0 flex items-center gap-2 px-7 py-3.5 bg-orange-500 text-white text-sm font-bold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-vip-crown-line" /> Get Factory Membership — $8/mo
            </Link>
          </div>

        </div>
      </div>

      {/* ===== SUBMIT FORM MODAL ===== */}
      {showForm && !submitted && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-start justify-center p-3 sm:p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl w-full max-w-2xl my-4" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="relative overflow-hidden rounded-t-2xl">
              <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-6 py-5">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-base font-extrabold text-white">Post Your Bulk Order Requirement</h2>
                    <p className="text-xs text-white/60 mt-0.5">Free · Your contact info is hidden from public · Only verified factory members can see it</p>
                  </div>
                  <button onClick={() => setShowForm(false)} className="w-8 h-8 flex items-center justify-center text-white/60 hover:text-white cursor-pointer rounded-full hover:bg-white/10">
                    <i className="ri-close-line text-xl" />
                  </button>
                </div>
              </div>
            </div>

            <form data-readdy-form id="home-buyer-requirement-form" onSubmit={handleSubmit} className="px-4 sm:px-6 py-5 space-y-4 max-h-[80vh] overflow-y-auto">
              {/* Privacy Notice */}
              <div className="flex items-start gap-3 bg-green-50 border border-green-100 rounded-xl p-4">
                <i className="ri-shield-check-fill text-green-500 text-lg flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs font-bold text-green-800 mb-0.5">Your Privacy is 100% Protected</p>
                  <p className="text-xs text-green-700 leading-relaxed">
                    Your WhatsApp &amp; email are <strong>completely hidden from the public</strong>. Only paid membership verified factories ($8/mo) can view your contact and send quotations.
                  </p>
                </div>
              </div>

              {/* Contact Info */}
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wide">Your Contact Information</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Full Name *</label>
                  <input name="buyerName" type="text" value={form.buyerName} onChange={(e) => set("buyerName", e.target.value)} placeholder="John Smith" className={`w-full px-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 transition-colors ${errors.buyerName ? "border-red-400" : "border-gray-200"}`} />
                  {errors.buyerName && <p className="text-xs text-red-500 mt-1">{errors.buyerName}</p>}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Company Name</label>
                  <input name="company" type="text" value={form.company} onChange={(e) => set("company", e.target.value)} placeholder="ABC Trading Co." className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:border-orange-400 transition-colors" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                    Email * <span className="text-green-600 font-normal">(hidden from public)</span>
                  </label>
                  <div className="relative">
                    <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input name="email" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="you@company.com" className={`w-full pl-9 pr-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 transition-colors ${errors.email ? "border-red-400" : "border-gray-200"}`} />
                  </div>
                  {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                    WhatsApp * <span className="text-green-600 font-normal">(hidden from public)</span>
                  </label>
                  <div className="relative">
                    <i className="ri-whatsapp-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input name="whatsapp" type="text" value={form.whatsapp} onChange={(e) => set("whatsapp", e.target.value)} placeholder="+1 555 000 0000" className={`w-full pl-9 pr-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 transition-colors ${errors.whatsapp ? "border-red-400" : "border-gray-200"}`} />
                  </div>
                  {errors.whatsapp && <p className="text-xs text-red-500 mt-1">{errors.whatsapp}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Your Country *</label>
                  <select name="country" value={form.country} onChange={(e) => set("country", e.target.value)} className={`w-full px-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 bg-white cursor-pointer transition-colors ${errors.country ? "border-red-400" : "border-gray-200"}`}>
                    <option value="">Select your country</option>
                    {SUBMIT_COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                  {errors.country && <p className="text-xs text-red-500 mt-1">{errors.country}</p>}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Product Category *</label>
                  <select name="category" value={form.category} onChange={(e) => set("category", e.target.value)} className={`w-full px-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 bg-white cursor-pointer transition-colors ${errors.category ? "border-red-400" : "border-gray-200"}`}>
                    <option value="">Select category</option>
                    {CATEGORIES_LIST.map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                  {errors.category && <p className="text-xs text-red-500 mt-1">{errors.category}</p>}
                </div>
              </div>

              {/* Requirement Details */}
              <p className="text-xs font-bold text-gray-400 uppercase tracking-wide pt-1">Requirement Details</p>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">Requirement Title *</label>
                <input name="title" type="text" value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="e.g. Wireless Earbuds ANC — 5,000 Units Bulk Order" className={`w-full px-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 transition-colors ${errors.title ? "border-red-400" : "border-gray-200"}`} />
                {errors.title && <p className="text-xs text-red-500 mt-1">{errors.title}</p>}
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Order Quantity *</label>
                  <input name="quantity" type="text" value={form.quantity} onChange={(e) => set("quantity", e.target.value)} placeholder="e.g. 5,000 units" className={`w-full px-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 transition-colors ${errors.quantity ? "border-red-400" : "border-gray-200"}`} />
                  {errors.quantity && <p className="text-xs text-red-500 mt-1">{errors.quantity}</p>}
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Budget Range</label>
                  <input name="budget" type="text" value={form.budget} onChange={(e) => set("budget", e.target.value)} placeholder="e.g. $50K–$80K" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:border-orange-400 transition-colors" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Target Delivery</label>
                  <input name="targetDelivery" type="text" value={form.targetDelivery} onChange={(e) => set("targetDelivery", e.target.value)} placeholder="e.g. June 2026" className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:border-orange-400 transition-colors" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                  Detailed Requirements * <span className="text-gray-400 font-normal">({form.description.length}/500)</span>
                </label>
                <textarea
                  name="description"
                  value={form.description}
                  onChange={(e) => { if (e.target.value.length <= 500) set("description", e.target.value); }}
                  maxLength={500}
                  rows={4}
                  placeholder="Describe your product specs, certifications, packaging, OEM/ODM needs, delivery port, etc."
                  className={`w-full px-3 py-2.5 border rounded-lg text-sm outline-none focus:border-orange-400 transition-colors resize-none ${errors.description ? "border-red-400" : "border-gray-200"}`}
                />
                {errors.description && <p className="text-xs text-red-500 mt-1">{errors.description}</p>}
              </div>

              {/* Privacy Agreement */}
              <div className="bg-gray-50 rounded-xl p-4">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input type="checkbox" name="agreePrivacy" checked={form.agreePrivacy} onChange={(e) => set("agreePrivacy", e.target.checked)} className="mt-0.5 accent-orange-500 cursor-pointer w-4 h-4 flex-shrink-0" />
                  <span className="text-xs text-gray-600 leading-relaxed">
                    I agree my contact info (email &amp; WhatsApp) is kept private and only shared with <strong>paid membership verified factories</strong> on StarBookPrime. I consent to receiving quotations from verified factories via email and WhatsApp.
                  </span>
                </label>
                {errors.agreePrivacy && <p className="text-xs text-red-500 mt-2">{errors.agreePrivacy}</p>}
              </div>

              <button type="submit" disabled={submitting} className="w-full py-3.5 bg-orange-500 text-white text-sm font-bold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-70">
                {submitting
                  ? <><i className="ri-loader-4-line animate-spin" /> Submitting...</>
                  : <><i className="ri-send-plane-line" /> Submit Requirement — Free</>
                }
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {submitted && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-green-50 rounded-full mx-auto mb-4">
              <i className="ri-checkbox-circle-fill text-4xl text-green-500" />
            </div>
            <h3 className="text-lg font-extrabold text-gray-900 mb-2">Requirement Submitted!</h3>
            <p className="text-sm text-gray-500 mb-2">Verified factories will review your requirement and send quotations directly to your email.</p>
            <p className="text-xs text-green-600 font-semibold mb-6 flex items-center justify-center gap-1">
              <i className="ri-shield-check-fill" /> Your contact info is kept 100% private
            </p>
            <button onClick={() => { setSubmitted(false); setShowForm(false); }} className="w-full py-3 bg-orange-500 text-white text-sm font-bold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap">
              Done
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
